/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import Dot from 'comps/Dot';
import type { ProjectT } from './types';
import useCommands from 'comps/Left2/useCommands';
import panels from 'comps/Left2/panels';

function SingleRecord(props: ProjectT): Element<string> {
  const { address, name, fillColor, teaserPhoto } = props;
  const cmd = useCommands();

  const addressLine = address && (
    <b
      style={{
        textTransform: 'uppercase',
        margin: '0 0 5px',
        display: 'block',
        fontSize: '0.9em',
      }}
    >
      {address}
    </b>
  );
  let photo = null;

  if (teaserPhoto) {
    const protocol = 'https://';
    const [base, imageId] = teaserPhoto.replace(protocol, '').split('/');
    const opts = 'resize=w:210,h:80,f:crop,a:center';
    const photoUrl = [protocol, base, opts, imageId].join('/');
    if (base === 'cdn.filestackcontent.com') {
      photo = <img src={photoUrl} />;
    }
  }

  const nameFontSize = addressLine ? '1.2em' : '1em';
  const dotOffsetTop = addressLine ? 4 : 2;

  function showItem() {
    cmd.showItemView(props);
    cmd.openPanel(panels.LOCATION_DETAILS);
  }

  return (
    <div className="project-popup-list">
      <div css={css({ display: 'grid', gridTemplateColumns: '20px 1fr' })}>
        <Dot
          dotStyle="fill"
          type="circle"
          color={fillColor || 'white'}
          containerStyle={{ top: dotOffsetTop }}
        />{' '}
        <div>
          <button
            onClick={showItem}
            className="btn-link text-left p-0"
            css={css({ fontSize: nameFontSize })}
          >
            {name}
          </button>
          {addressLine}
        </div>
      </div>
      {photo}
    </div>
  );
}

export default SingleRecord;
